<template>
    <div id="startintervention">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outercircle">
            <div class="homeName">
                Planning
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            {{title}}
        </h1>
        <center>
            <i>{{intervention.name}}</i>
        </center>
        <div class="divCard">
            <span class="spanCardtitle">
                Créer/Modifier la fiche d'intervention
            </span>
            <span v-if="!isInterventionSheet" class="spanCardstatus">
                Fiche manquante
            </span>
            <button v-on:click="openModalSheet()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
                Avis déposé
            </span>
            <span class="spanCardtype">
                <i>{{avisPassage}}</i>
            </span>
            <button v-on:click="openModalNotice()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
                Prendre une photo
            </span>
            <span class="spanCardtype">
                <i>{{nbPic}}</i>
            </span>
            <span v-if="nbPic === 'Aucune photo' || nbPic === '1 photo' || nbPic === '2 photos' || nbPic === '3 photos'" class="spanCardstatus">
                Photo manquante, 4 photos requises
            </span>
            <input type="file" ref="filepic" @change="readURLPicture" style="display: none">
            <button v-on:click="$refs.filepic.click()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
                Croquis
            </span>
            <span class="spanCardtype">
                <i>{{sketchStatus}}</i>
            </span>
            <button v-on:click="openModalSketch()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
                Documents associés
            </span>
            <span class="spanCardtype">
                <i v-if="nbDoc === 0">Aucun fichier</i>
                <i v-if="nbDoc === 1">{{nbDoc}} fichier</i>
                <i v-if="nbDoc > 1">{{nbDoc}} fichiers</i>
            </span>
            <button v-on:click="goToInterventionDetail()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div v-if="isGaz" class="divCard">
            <span class="spanCardtitle">
                Cerfa d'attestation d'entretien de chaudière gaz
            </span>
            <span v-if="!isGazFilled" class="spanCardstatus">
                Cerfa vide, non obligatoire
            </span>
            <button v-on:click="goToCerfaGAZDetail()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div v-if="isFioul" class="divCard">
            <span class="spanCardtitle">
                Cerfa d'attestation d'entretien de chaudière au fioul
            </span>
            <span v-if="!isFioulFilled" class="spanCardstatus">
                Cerfa vide, non obligatoire
            </span>
            <button v-on:click="goToCerfaFIOULDetail()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
                Cerfa d'attestation TVA
            </span>
            <span class="spanCardtype">
                <i v-if="isTVAFilled">Cerfa déjà complété</i>
                <i v-else>Cerfa vide</i>
            </span>
            <button v-on:click="goToCerfaTVADetail()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
                Cerfa de suivi des déchets dangereux
            </span>
            <span class="spanCardtype">
                <i v-if="isClimFilled">Cerfa déjà complété</i>
                <i v-else>Cerfa vide</i>
            </span>
            <button v-on:click="goToCerfaCLIMDetail()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
        <div class="outercircle">
            <button id="modify" type="button" v-on:click="endIntervention()">Terminer</button>
        </div>
        <modal height="80%" width="80%" name="sketchModal">
            <div class="modalDiv fullheight" >
                <div class="txtDiv">
                    <span class="modalTxt"><b>Croquis :</b></span>
                </div>    
                <VueSignaturePad  width="100%" height="calc(80vh - 165px)" :class="sigpadclass" ref="signaturePad" />    
                <button class="docBtn3 marginBotTop" type="button" v-on:click="validateSketch()">Enregistrer</button>   
            </div>
        </modal>
        <modal height="250px" name="finishmodal">
            <div class="modalDiv">
                <h2>Terminer l'intervention</h2>
                <b class="textLen">Renseigner le status de l'intervention :</b>
                <select class="inputTxt select" v-model="nextInterventionStatus">
                    <option class="inputTxt" :value="'en attente de rendez-vous'" selected>
                        En attente de rendez-vous
                    </option>
                    <option class="inputTxt" :value="'en attente de devis'">
                        En attente de devis
                    </option>
                    <option class="inputTxt" :value="'en attente de facture'">
                        En attente de facture
                    </option>
                    <option class="inputTxt" :value="'à statuer'">
                        à statuer
                    </option>
                </select>
                <button class="docBtn3" type="button" v-on:click="uploadFinishedIntervention()">Terminer l'intervention</button>   
            </div>    
        </modal>
        <modal height="95%" name="signaturemodal">
            <div class="modalDiv">
                <h2>Terminer l'intervention</h2>
                <div class="textline">
                    <b class="textLen">Temps technicien principal :</b>
                    <input class="inputSmall" v-model="mainTechHour"> h 
                    <input class="inputSmall" v-model="mainTechMinute"> min
                </div> 
                <div class="textline" v-for="(itemInterim, indexInterim) in interimHour" :key="indexInterim">
                    <b class="textLen">Temps intérimaire :</b>
                    <input class="inputSmall" v-model="interimHour[indexInterim]"> h
                    <input class="inputSmall" v-model="interimMinute[indexInterim]"> min
                </div> 
                <div class="textline" v-for="help in helpHour.length" :key="help">
                    <b class="textLen">Temps technicien aide :</b>
                    <input class="inputSmall" v-model="helpHour[help-1]"> h
                    <input class="inputSmall" v-model="helpMinute[help-1]"> min
                </div> 
                <div class="textline">
                    <b class="textLen">Temps passé cumulé :</b>
                    <input class="inputSmallDis" v-model="cumulateHour" disabled="disabled"> h
                    <input class="inputSmallDis" v-model="cumulateMinute" disabled="disabled"> min
                </div> 
                <div class="textline">
                    <b >Signature technicien :</b><br>
                    <VueSignaturePad  width="60%" height="100px" :class="sigpadclass" ref="signaturePadTech" />
                </div> 
                <div class="textline">
                    <b >Signature client :</b><br>
                    <VueSignaturePad  width="60%" height="100px" :class="sigpadclass" ref="signaturePadCustomer" />
                </div>
                <button class="docBtn3" type="button" v-on:click="validateSignature()">Valider</button>   
            </div>    
        </modal>
        <modal style="z-index:9999;" height="250px" width="400px" name="validationModal">
            <div class="modalDiv">  
                <div class="txtDiv">
                    <img class="modalTxt" :src="imgValidation"/>
                </div>  
                <div class="txtDiv">
                    <span class="modalTxt">{{validationPhrase}}</span>
                </div>    
                <button class="docBtn3" type="button" v-on:click="okButton()">OK</button>   
            </div>    
        </modal>
        <modal height="80%" name="sheetmodal">
            <div>
                <div style="margin:30px;" v-if="stepSheet === 1" >
                    <h2 class="modalDivCenter">Fiche d'intervention</h2>
                    <div class="txtDiv" style="background-color:#fff; border-radius: 5px;">
                        <div class="modalTxt twocolumns">
                            <div v-html="txtLocataire"></div>
                            <div v-html="txtProprio"></div>
                        </div>
                    </div>    
                    <div class="txtDiv modalDivCenter">
                        <button class="bigBtn " type="button" v-on:click="toInformationPage()">Informations intervention ({{nbInfo}})</button>  
                    </div>
                    <div class="txtDiv modalDivCenter">
                        <button class="bigBtn " type="button" v-on:click="toActionPage()">Actions de recherche de fuite ({{nbAction}})</button>  
                    </div>  
                    <div class="txtDiv modalDivCenter">
                        <button class="docBtn4 " type="button" v-on:click="saveSheet()">Valider</button>   
                    </div>
                </div> 
                <div v-if="stepSheet === 2" style="margin:30px;">
                    <h2 class="modalDivCenter">Fiche d'intervention - Informations intervention</h2>
                    <div class="txtDiv">
                        <div v-for="i in nbInfo" :key="i">
                            <div style="background-color:#ddd; border-radius: 5px; margin-bottom:10px;"  class="modalDivCenter">
                                <span>{{interventionSheet.information[i-1].note}}</span><br>
                                <span>{{interventionSheet.information[i-1].status}}</span>
                            </div>
                        </div>
                        <button class="btnNewBtn" v-on:click="toInformationDetailPage()"><font-awesome-icon icon="plus" />
                        </button>
                        Ajouter  
                    </div>  
                    <div class="txtDiv modalDivCenter">
                        <button class="docBtn4 " type="button" v-on:click="toHomeSheet()">Retour</button>   
                    </div>
                </div>
                <div v-if="stepSheet === 3" style="margin:30px;">
                    <h2 class="modalDivCenter">Fiche d'intervention - Action</h2>
                    <div class="txtDiv">
                        <div v-for="j in interventionSheet.action.length" :key="j">
                            <div style="background-coor:#ddd; border-radius: 5px;"  class="modalDivCenter">
                                <span><b>{{interventionSheet.action[j-1].name}} :</b></span>
                                <input style="display:inline-block;" class="modalCheck" type="checkbox" name="isInternal" v-model="interventionSheet.action[j-1].isInternal" :value="true">
                                <span>Interne</span>
                                <input style="display:inline-block;" class="modalCheck" type="checkbox" name="isExternal" v-model="interventionSheet.action[j-1].isExternal" :value="true">
                                <span>Externe</span><br>
                                <b style="display:block;">Travail effectué :</b>
                                <textarea rows="2" class="inputTxt area" type="text" v-model="interventionSheet.action[j-1].report"></textarea><br><br>
                            </div>
                        </div>
                    </div>  
                    <div class="txtDiv modalDivCenter">
                        <button class="docBtn4 " type="button" v-on:click="toHomeSheet()">Retour</button>   
                    </div>
                </div>
                <div v-if="stepSheet === 4" style="margin:30px;">
                    <h2 class="modalDivCenter">Fiche d'intervention - Informations intervention</h2>
                    <div class="txtDiv">
                        <b style="display:block;">Travail effectué :</b>
                        <textarea rows="6" class="inputTxt area" type="text" v-model="interventionSheet.information[nbInfo-1].note"></textarea>                          
                    </div>
                    <div>
                        <div class="textline">
                            <div class="modalDivCenter">
                                <input style="display:inline-block;" class="radioBtn" type="radio" name="isJointOwnershipRadio" value="Terminé" v-model="interventionSheet.information[nbInfo-1].status">
                                <span>Terminé</span>
                                <input style="display:inline-block;" class="radioBtn" type="radio" name="isJointOwnershipRadio" value="En cours" v-model="interventionSheet.information[nbInfo-1].status">
                                <span>En cours</span>
                                <input style="display:inline-block;" class="radioBtn" type="radio" name="isJointOwnershipRadio" value="Non terminé" v-model="interventionSheet.information[nbInfo-1].status" checked>
                                <span>Non terminé</span><br>
                            </div>
                        </div>
                    </div>
                    <div class="txtDiv modalDivCenter">
                        <button class="docBtn4 " type="button" v-on:click="toInformationPage()">Valider</button>   
                    </div>
                </div>
            </div>
        </modal>
        <modal height="80%" name="NoticeFiledModal">
            <div class="modalDiv">
                <h2>Avis déposé</h2>
                <div class="textline">
                    <input class="radioBtn" type="radio" name="isJointOwnershipRadio" :value="false" v-model="NoticeFiled.isWaterBreak">
                    <span>Avis de passage</span>
                    <input class="radioBtn" type="radio" name="isJointOwnershipRadio" :value="true" v-model="NoticeFiled.isWaterBreak" checked>
                    <span>Avis de coupure d'eau</span><br>
                </div>
                <div class="textline">
                    <b class="textLen">Date de début de <span v-if="NoticeFiled.isWaterBreak">coupure</span><span v-else>passage</span> :</b>
                    <datepicker @selected="changeHandler()" input-class="inputDate" class="wrapperDateSmall" :language="fr" v-model="pick.start.date"></datepicker>
                </div>
                <div class="textline">
                    <b class="textLen">Heure de début de <span v-if="NoticeFiled.isWaterBreak">coupure</span><span v-else>passage</span> :</b>
                    <vue-timepicker @change="changeHandler()" class="wrapperDateSmall" :minute-interval="5" v-model="pick.start.hour" hide-clear-button></vue-timepicker>
                </div>
                <div v-if="NoticeFiled.isWaterBreak" class="textline">
                    <b class="textLen">Date de fin de <span v-if="NoticeFiled.isWaterBreak">coupure</span><span v-else>passage</span> :</b>
                    <datepicker @selected="changeHandler()" input-class="inputDate" class="wrapperDateSmall" :language="fr" v-model="pick.end.date"></datepicker>
                </div>
                <div v-if="NoticeFiled.isWaterBreak" class="textline">
                    <b class="textLen">Heure de fin de <span v-if="NoticeFiled.isWaterBreak">coupure</span><span v-else>passage</span> :</b>
                    <vue-timepicker @change="changeHandler()" class="wrapperDateSmall" :minute-interval="5" v-model="pick.end.hour" hide-clear-button></vue-timepicker>
                </div>
                <div class="textline marginBotTop">
                    <b class="textLen">Ajouter une photo :</b>
                    <input type="file" ref="file" @change="readURL" style="display: none">
                    <button v-on:click="$refs.file.click()" class="btnCardCamera"><font-awesome-icon icon="camera" /></button>
                </div>
                <button class="docBtn3" type="button" v-on:click="uploadPicture()">Valider</button>
            </div>    
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import Datepicker from 'vuejs-datepicker';
    import {fr} from 'vuejs-datepicker/dist/locale'
    import VueTimepicker from 'vue2-timepicker'

    export default {
        name: 'Startintervention',
        components: {
            Datepicker,
            VueTimepicker
        },
        data() {
            return {
                ModalType: "Type d'intervention inconnue",
                ModalAddress: "Adresse de l'intervention inconnue",
                ModalNote: "Notes de l'intervention vide",
                validationPhrase: "L'avis a été correctement enregistré",
                sketchStatus:"Pas de croquis",
                imgValidation: "/assets/right.png",
                Name:"Client",
                sigpadclass: "signature",
                id:"",
                txtLocataire:"<b class='textLenSheet'>Locataire :</b> Coordonnées inconnues<br><br><br><br>",
                txtProprio:"<b class='textLenSheet'>Propriétaire :</b> Coordonnées inconnues<br><br><br><br>",
                stepSheet:1,
                sketch:"/assets/nosketch.png",
                indexInfo:0,
                techSignature:"/assets/nosignature.png",
                customerSignature:"/assets/nosignature.png",
                nextInterventionStatus:"en attente de rendez-vous",
                mainTechHour:"0",
                mainTechMinute:"0",
                interimHour:["0"],
                interimMinute:["0"],
                helpHour:["0"],
                helpMinute:["0"],
                cumulateHour:"0",
                cumulateMinute:"0",
                nbInfo:0,
                nbAction:0,
                isFioul:false,
                isGaz:false,
                isClim:false,
                isFioulFilled:false,
                isGazFilled:false,
                isClimFilled:false,
                isTVAFilled:false,
                interventionSheet:{
                    action:[
                        {
                            name:"Passage caméra avec rapport simplifié",
                            report:"",
                            isInternal :false,
                            isExternal :false
                        },
                        {
                            name:"Fuite alimentation apparente",
                            report:"",
                            isInternal :false,
                            isExternal :false
                        },
                        {
                            name:"Fuite alimentation enterrée/encastrée",
                            report:"",
                            isInternal :false,
                            isExternal :false
                        }
                    ],
                    information:[]
                },
                fr:fr,
                pick:{
                    start:{
                        date: new Date(2016, 9,  16),
                        hour: {
                                HH: "10",
                                mm: "05",
                                ss: "00"
                            },
                    },
                    end:{
                        date: new Date(2016, 9,  16),
                        hour: {
                                HH: "10",
                                mm: "05",
                                ss: "00"
                            },
                    }
                },
                NoticeFiled: {
                    startTimestamp:0,
                    endTimestamp:0,
                    isWaterBreak:true,
                    picture:{
                        lastModified: {},
                        fileType: "image/png",
                        resizedFile: {},
                        imageType: "",
                        imgUrl:"/assets/add_picture_long.png",
                        files:[],
                        isUpload:false
                    }
                },
                title: "",
                isMain: false,
                isInterventionSheet: false,
                intervention:{},
                coupurePassage:"coupure",
                avisPassage:"Pas d'avis",
                nbPic:"Aucune photo",
                inquiry:{},
                building:{},
                user: {},
                nbDoc:0,
                picture:{
                    lastModified: {},
                    fileType: "image/png",
                    resizedFile: {},
                    imageType: "",
                    imgUrl:"/assets/add_picture_long.png",
                    files:[]
                }
            };
        },
        watch: {
            mainTechHour: function (){
                    var LOCinterimTime =[];
                    var LOChelpTime =[];
                    var LOCcumulateTime =0;
                    var foundHelp = false;
                    var foundInt = false;

                    for(var f=0; f<this.intervention.planning.length; f++){
                        if(!this.intervention.planning[f].isEstimated){
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain){
                                LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                            }
                            if(!this.intervention.planning[f].isEstimated && !this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire")===-1){
                                foundHelp = false;
                                for(var g=0; g<LOChelpTime.length; g++){
                                    if(LOChelpTime[g].user === this.intervention.planning[f].user.idWeweb){
                                        foundHelp = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOChelpTime[g].time = LOChelpTime[g].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundHelp){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOChelpTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire") > -1){
                                foundInt = false;
                                for(var h=0; h<LOCinterimTime.length; h++){
                                    if(LOCinterimTime[h].user === this.intervention.planning[f].user.idWeweb){
                                        foundInt = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOCinterimTime[h].time = LOCinterimTime[h].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundInt){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOCinterimTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                        }
                    }

                    LOCcumulateTime = LOCcumulateTime + parseInt(this.mainTechMinute)*60+parseInt(this.mainTechHour)*3600;

                    this.cumulateHour = Math.floor(""+LOCcumulateTime / 3600);
                    this.cumulateMinute = Math.floor(""+LOCcumulateTime % 3600 / 60);
            },
            mainTechMinute: function (){
                    var LOCinterimTime =[];
                    var LOChelpTime =[];
                    var LOCcumulateTime =0;
                    var foundHelp = false;
                    var foundInt = false;

                    for(var f=0; f<this.intervention.planning.length; f++){
                        if(!this.intervention.planning[f].isEstimated){
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain){
                                LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                            }
                            if(!this.intervention.planning[f].isEstimated && !this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire")===-1){
                                foundHelp = false;
                                for(var g=0; g<LOChelpTime.length; g++){
                                    if(LOChelpTime[g].user === this.intervention.planning[f].user.idWeweb){
                                        foundHelp = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOChelpTime[g].time = LOChelpTime[g].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundHelp){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOChelpTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire") > -1){
                                foundInt = false;
                                for(var h=0; h<LOCinterimTime.length; h++){
                                    if(LOCinterimTime[h].user === this.intervention.planning[f].user.idWeweb){
                                        foundInt = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOCinterimTime[h].time = LOCinterimTime[h].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundInt){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOCinterimTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                        }
                    }

                    LOCcumulateTime = LOCcumulateTime + parseInt(this.mainTechMinute)*60+parseInt(this.mainTechHour)*3600;

                    this.cumulateHour = Math.floor(""+LOCcumulateTime / 3600);
                    this.cumulateMinute = Math.floor(""+LOCcumulateTime % 3600 / 60);
                
            },
            NoticeFiled : {
                handler: function (val, oldVal){

                    console.log(val+""+oldVal);
                    
                    if(this.NoticeFiled.isWaterBreak){
                        this.coupurePassage = "coupure"
                    }
                    else{
                        this.coupurePassage = "passage"
                    }
                },
                deep:true              
            }
        },
        methods:{
            openModalNotice(){
                this.$modal.show('NoticeFiledModal');
            },
            closeModalNotice(){
                this.$modal.hide('NoticeFiledModal');
            },
            openModalValidation(){
                this.$modal.show('validationModal');
            },
            closeModalValidation(){
                this.$modal.hide('validationModal');
            },
            openModalSignature(){
                this.$modal.show('signaturemodal');
            },
            closeModalSignature(){
                this.$modal.hide('signaturemodal');
            },
            openModalFinish(){
                this.$modal.show('finishmodal');
            },
            closeModalFinish(){
                this.$modal.hide('finishmodal');
            },
            openModalSheet(){
                this.$modal.show('sheetmodal');
            },
            closeModalSheet(){
                this.$modal.hide('sheetmodal');
            },
            openModalSketch(){
                this.$modal.show('sketchModal');
            },
            closeModalSketch(){
                this.$modal.hide('sketchModal');
            },
            okButton(){
                this.$modal.hide('validationModal');                
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "techhome" });
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('history');
                this.$cookie.delete('historyQuery');
                this.$router.replace({ name: "login" });
            },
            toHomeSheet(){
                this.nbAction = 0;
                for(var i=0; i<this.interventionSheet.action.length; i++){
                    if(this.interventionSheet.action[i].isInternal || this.interventionSheet.action[i].isExternal){
                        this.nbAction = this.nbAction+1;
                    }
                }
                this.stepSheet = 1;
            },
            validateSignature(){
                
                const { isEmpty, data } = this.$refs.signaturePadTech.saveSignature();
                if(isEmpty){
                    this.validationPhrase =  "Le technicien doit signer le document",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
                else{
                    this.techSignature = data;
                    this.validateSignature2();
                }
            },
            validateSignature2(){
                const { isEmpty, data } = this.$refs.signaturePadCustomer.saveSignature();
                if(isEmpty){
                    this.validationPhrase =  "Le client doit signer le document",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
                else{
                    this.customerSignature = data;
                    if(this.techSignature && this.customerSignature){
                        this.uploadSignatureTech();
                    }
                    else{
                        this.validationPhrase =  "Signature manquante",
                        this.imgValidation = "/assets/wrong.png",
                        this.openModalValidation();
                    }
                }
            },
            toInformationDetailPage(){
                this.nbInfo = this.nbInfo+1;
                this.interventionSheet.information.push(
                            {note: "",
                            status:  "Non terminé"});
                this.stepSheet = 4;
            },
            toActionDetailPage(){
                this.stepSheet = 5;
            },
            toInformationPage(){
                this.stepSheet = 2;
            },
            toActionPage(){
                this.stepSheet = 3;
            },
            goToInterventionDetail(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "interventiondetailtech", query:{name:this.$route.query.name}});                
            },
            goToCerfaTVADetail(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "cerfatva", query:{name:this.$route.query.name}});                
            },
            goToCerfaGAZDetail(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "cerfagaz", query:{name:this.$route.query.name}});
            },
            goToCerfaFIOULDetail(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "cerfafioul", query:{name:this.$route.query.name}});
            },
            goToCerfaCLIMDetail(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "cerfaclim", query:{name:this.$route.query.name}});
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "techhome" });
                }
            },
            changeHandler(){
                var fin = this.pick.end.date;
                fin.setHours(parseInt(this.pick.end.hour.HH), parseInt(this.pick.end.hour.mm, 0, 0));

                var debut = this.pick.start.date;
                debut.setHours(parseInt(this.pick.start.hour.HH), parseInt(this.pick.start.hour.mm, 0, 0));

                this.NoticeFiled.startTimestamp = (debut / 1000 |0);
                this.NoticeFiled.endTimestamp = (fin/1000 |0);
            },
            readURLPicture(event){
                this.picture.imgUrl = URL.createObjectURL(event.target.files[0]);
                this.picture.files = event.target.files;
                this.picture.lastModified = event.target.files[0].lastModifiedDate;
                this.picture.fileType = event.target.files[0].type;
                
                var extension = this.picture.files[0].name.substring(this.picture.files[0].name.lastIndexOf(".")+1).toLowerCase();
                if(extension !== "jpg" && extension !== "png" && extension !== "jpeg" && extension !== "gif"){
                    alert("Image au mauvais format, veuillez réessayer avec un fichier PNG ou JPG");
                }
                else{
                    this.resizeImgPicture(event);
                }
            },
            resizeImgPicture(event){

                this.picture.files = event.target.files;
                var current_file = this.picture.files[0];
                var reader = new FileReader();

                var vm = this;
                
                reader.onload = function (event) {
                    var image = new Image();
                    image.src = event.target.result;
                    image.onload = function() {
                        var maxWidth = 500,
                            maxHeight = 250,
                            imageWidth = image.width,
                            imageHeight = image.height;
                        if (imageWidth > imageHeight) {
                            if (imageWidth > maxWidth) {
                                imageHeight *= maxWidth / imageWidth;
                                imageWidth = maxWidth;
                            }
                        }
                        else {
                            if (imageHeight > maxHeight) {
                                imageWidth *= maxHeight / imageHeight;
                                imageHeight = maxHeight;
                            }
                        }
                        var canvas = document.createElement('canvas');
                        canvas.style.display = "none";
                        canvas.width = imageWidth;
                        canvas.height = imageHeight;
                        image.width = imageWidth;
                        image.height = imageHeight;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(this, 0, 0, imageWidth, imageHeight);

                        var BASE64_MARKER = ';base64,';
                        var raw;
                        var contentType;
                        var parts;
                        if (canvas.toDataURL(current_file.type).indexOf(BASE64_MARKER) == -1) {
                            parts = canvas.toDataURL(current_file.type).split(',');
                            contentType = parts[0].split(':')[1];
                            raw = parts[1];
                            vm.picture.resizedFile = new File([new Blob([raw], {type: contentType})], "name", {type: vm.picture.fileType, lastModified: vm.picture.lastModified});
                        }
                        else{
                            parts = canvas.toDataURL(current_file.type).split(BASE64_MARKER);
                            contentType = parts[0].split(':')[1];
                            raw = window.atob(parts[1]);
                            var rawLength = raw.length;
                            var uInt8Array = new Uint8Array(rawLength);

                            for (var i = 0; i < rawLength; ++i) {
                                uInt8Array[i] = raw.charCodeAt(i);
                            }
                            vm.picture.resizedFile = new File([new Blob([uInt8Array], {type: contentType})], "name", {type: vm.picture.fileType, lastModified: vm.picture.lastModified});
                        }
                        vm.uploadBasicPicture();
                    }
                }
                reader.readAsDataURL(current_file);
                
            },
            readURL(event) {
                this.NoticeFiled.picture.imgUrl = URL.createObjectURL(event.target.files[0]);
                this.NoticeFiled.picture.files = event.target.files;
                this.NoticeFiled.picture.lastModified = event.target.files[0].lastModifiedDate;
                this.NoticeFiled.picture.fileType = event.target.files[0].type;
                
                var extension = this.NoticeFiled.picture.files[0].name.substring(this.NoticeFiled.picture.files[0].name.lastIndexOf(".")+1).toLowerCase();
                if(extension !== "jpg" && extension !== "png" && extension !== "jpeg" && extension !== "gif"){
                    alert("Image au mauvais format, veuillez réessayer avec un fichier PNG ou JPG");
                }
                else{
                    this.resizeImg(event);
                }
            },
            resizeImg(event){

                this.NoticeFiled.picture.files = event.target.files;
                var current_file = this.NoticeFiled.picture.files[0];
                var reader = new FileReader();

                var vm = this;
                
                reader.onload = function (event) {
                    var image = new Image();
                    image.src = event.target.result;
                    image.onload = function() {
                        var maxWidth = 500,
                            maxHeight = 250,
                            imageWidth = image.width,
                            imageHeight = image.height;
                        if (imageWidth > imageHeight) {
                            if (imageWidth > maxWidth) {
                                imageHeight *= maxWidth / imageWidth;
                                imageWidth = maxWidth;
                            }
                        }
                        else {
                            if (imageHeight > maxHeight) {
                                imageWidth *= maxHeight / imageHeight;
                                imageHeight = maxHeight;
                            }
                        }
                        var canvas = document.createElement('canvas');
                        canvas.style.display = "none";
                        canvas.width = imageWidth;
                        canvas.height = imageHeight;
                        image.width = imageWidth;
                        image.height = imageHeight;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(this, 0, 0, imageWidth, imageHeight);

                        var BASE64_MARKER = ';base64,';
                        var raw;
                        var contentType;
                        var parts;
                        if (canvas.toDataURL(current_file.type).indexOf(BASE64_MARKER) == -1) {
                            parts = canvas.toDataURL(current_file.type).split(',');
                            contentType = parts[0].split(':')[1];
                            raw = parts[1];
                            vm.NoticeFiled.picture.resizedFile = new File([new Blob([raw], {type: contentType})], "name", {type: vm.NoticeFiled.picture.fileType, lastModified: vm.NoticeFiled.picture.lastModified});
                        }
                        else{
                            parts = canvas.toDataURL(current_file.type).split(BASE64_MARKER);
                            contentType = parts[0].split(':')[1];
                            raw = window.atob(parts[1]);
                            var rawLength = raw.length;
                            var uInt8Array = new Uint8Array(rawLength);

                            for (var i = 0; i < rawLength; ++i) {
                                uInt8Array[i] = raw.charCodeAt(i);
                            }
                            vm.NoticeFiled.picture.isUpload = true;
                            vm.NoticeFiled.picture.resizedFile = new File([new Blob([uInt8Array], {type: contentType})], "name", {type: vm.NoticeFiled.picture.fileType, lastModified: vm.NoticeFiled.picture.lastModified});
                        }
                    }
                }
                reader.readAsDataURL(current_file);
                
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "technicien chantier" || !this.$route.query.name  || !this.$cookie.get('idWeweb')){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    
                    var dateNow = new Date() / 1000 | 0;
                    this.NoticeFiled.startTimestamp = (dateNow - (dateNow%1800));
                    this.NoticeFiled.endTimestamp = 1800 + (dateNow - (dateNow%1800));
                    

                    this.pick.start.date = new Date(this.NoticeFiled.startTimestamp*1000)
                    this.pick.end.date = new Date(this.NoticeFiled.endTimestamp*1000)

                    this.pick.start.hour = {
                                                HH:("0" + new Date(this.NoticeFiled.startTimestamp*1000).getHours()).substr(-2),
                                                mm:("0" + new Date(this.NoticeFiled.startTimestamp*1000).getMinutes()).substr(-2),
                                                ss:"00"
                                            };
                                                
                    this.pick.end.hour = {
                                                HH:("0" + new Date(this.NoticeFiled.endTimestamp*1000).getHours()).substr(-2),
                                                mm:("0" + new Date(this.NoticeFiled.endTimestamp*1000).getMinutes()).substr(-2),
                                                ss:"00"
                                            };
                    this.getIntervention();
                }
            },
            validateSketch() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                if(isEmpty){
                    this.validationPhrase =  "Veuillez remplir le croquis",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
                else{
                    this.sketch = data;
                    this.uploadSketch();
                }
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            endIntervention(){
                if(this.isMain){
                    if(this.nbPic === "Aucune photo" || this.nbPic === '1 photo' || this.nbPic === '2 photos' || this.nbPic === '3 photos' || !this.isInterventionSheet || !this.isFioulFilled || !this.isGazFilled){
                        this.validationPhrase =  "Fiche d'intervention, Cerfa ou photo manquante, veuillez les compléter avant de terminer l'intervention",
                        this.imgValidation = "/assets/wrong.png",
                        this.openModalValidation();
                    }
                    else{
                        this.openModalSignature();
                    }
                }
                else{
                    this.validationPhrase =  "Vous devez être le technicien principal pour terminer l'intervention",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async saveSheet(){

                if(this.nbAction >0 && this.nbInfo >0){

                    var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/intervention/interventionsheet/'+this.$route.query.name, {interventionsheet:this.interventionSheet});

                    if(response){
                        this.closeModalSheet();
                        this.isInterventionSheet = true;
                        this.validationPhrase =  "La fiche d'intervention a été correctement enregistrée",
                        this.imgValidation = "/assets/right.png",
                        this.openModalValidation();
                    }
                    else{
                        this.closeModalSheet();
                        this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                        this.imgValidation = "/assets/wrong.png",
                        this.openModalValidation();
                    }
                }
                else{
                    this.validationPhrase =  "Il doit y avoir au moins une action et une information pour valider la fiche d'intervention",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async uploadFinishedIntervention(){
                
                this.intervention.status = this.nextInterventionStatus;

                var newPlannings = [];
                var indexHelp = 0;
                var indexInt = 0;

                for(var i=0; i<this.intervention.planning.length; i++){
                    if(this.intervention.planning[i].isMain){
                        
                        newPlannings.push({
                            user:               this.intervention.planning[i].user,
                            activityType:       this.intervention.planning[i].activityType,
                            startTimestamp :    this.intervention.planning[i].startTimestamp,
                            endTimestamp :      this.intervention.planning[i].startTimestamp+parseInt(this.mainTechHour)*3600+parseInt(this.mainTechMinute)*60,
                            isMain :            this.intervention.planning[i].isMain,
                            isRemote :          this.intervention.planning[i].isRemote,
                            isEstimated :       false,
                            addressStr:         this.intervention.planning[i].addressStr,
                            note:               this.intervention.planning[i].note
                        })
                    }
                    if(!this.intervention.planning[i].isMain && this.intervention.planning[i].user.idWeweb.indexOf("interimaire")===-1){
                        
                        newPlannings.push({
                            user:               this.intervention.planning[i].user,
                            activityType:       this.intervention.planning[i].activityType,
                            startTimestamp :    this.intervention.planning[i].startTimestamp,
                            endTimestamp :      this.intervention.planning[i].startTimestamp+parseInt(this.helpHour[indexHelp])*3600+parseInt(this.helpMinute[indexHelp])*60,
                            isMain :            this.intervention.planning[i].isMain,
                            isRemote :          this.intervention.planning[i].isRemote,
                            isEstimated :       false,
                            addressStr:         this.intervention.planning[i].addressStr,
                            note:               this.intervention.planning[i].note
                        })
                        indexHelp++;
                    }
                    if(this.intervention.planning[i].isMain && this.intervention.planning[i].user.idWeweb.indexOf("interimaire") > -1){
                        
                        newPlannings.push({
                            user:               this.intervention.planning[i].user,
                            activityType:       this.intervention.planning[i].activityType,
                            startTimestamp :    this.intervention.planning[i].startTimestamp,
                            endTimestamp :      this.intervention.planning[i].startTimestamp+parseInt(this.interimHour[indexInt])*3600+parseInt(this.interimMinute[indexInt])*60,
                            isMain :            this.intervention.planning[i].isMain,
                            isRemote :          this.intervention.planning[i].isRemote,
                            isEstimated :       false,
                            addressStr:         this.intervention.planning[i].addressStr,
                            note:               this.intervention.planning[i].note
                        })
                        indexInt++;
                    }
                }

                for(var j=0; j<newPlannings.length; j++){
                    this.intervention.planning.push(newPlannings[j]);
                }

                var newIntervention ={};
                newIntervention.status = this.nextInterventionStatus;
                newIntervention.type = this.intervention.type;
                newIntervention.isRemote = this.intervention.isRemote;
                newIntervention.note = this.intervention.note;
                newIntervention.planning = this.intervention.planning;
                newIntervention.emailRDV = [];
                newIntervention.emailReminder = [];

                console.log(newIntervention);

                var response = await axios.post('https://so.gaviota.fr/api/building/inquiry/intervention/all/'+this.inquiry.name +"/"+this.$route.query.name, {intervention: newIntervention});

                if(response){
                    this.reload();
                }
                else{
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async uploadSignatureTech(){

                var file = this.dataURLtoFile(this.techSignature, 'picture.png');
                const fd = new FormData();
                fd.append('picture', file ,"picture.png");
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/intervention/techsignature/'+this.$route.query.name, fd);
                
                if(response){
                    this.uploadSignatureCust();
                }
                else{
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async uploadSignatureCust(){

                var file = this.dataURLtoFile(this.customerSignature, 'picture.png');
                const fd = new FormData();
                fd.append('picture', file ,"picture.png");
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/intervention/customersignature/'+this.$route.query.name, fd);
                
                if(response){
                    this.closeModalSignature();
                    this.openModalFinish();
                }
                else{
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async uploadSketch(){

                var file = this.dataURLtoFile(this.sketch, 'picture.png');
                const fd = new FormData();
                fd.append('picture', file ,"picture.png");
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/intervention/sketch/'+this.$route.query.name, fd);
                
                if(response){
                    this.closeModalSketch();
                    this.sketchStatus = "Croquis déjà enregistré";
                    this.validationPhrase =  "Le croquis a été correctement enregistré",
                    this.imgValidation = "/assets/right.png",
                    this.openModalValidation();
                }
                else{
                    this.closeModalSketch();
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async uploadBasicPicture(){
                const fd = new FormData();
                fd.append('picture', this.picture.resizedFile ,'picture');
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/intervention/picture/'+this.$route.query.name, fd);
                
                if(response){
                    if(this.nbPic === "Aucune photo"){
                       this.nbPic = "1 photo" 
                    }
                    else{
                        var nb = parseInt(this.nbPic.substr(0, this.nbPic.indexOf("photo")-1));
                        nb++;
                        this.nbPic = nb+" photos";
                    }
                    this.validationPhrase =  "La photo a été correctement enregistré",
                    this.imgValidation = "/assets/right.png",
                    this.openModalValidation();
                }
                else{
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async uploadPicture(){
                if(this.NoticeFiled.picture.isUpload){
                    this.closeModalNotice();
                    const fd = new FormData();
                    fd.append('picture', this.NoticeFiled.picture.resizedFile ,'picture');
                
                    var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/intervention/noticefiled/'+this.$route.query.name+'/'+this.NoticeFiled.startTimestamp+'/'+this.NoticeFiled.endTimestamp+'/'+this.NoticeFiled.isWaterBreak, fd);

                    if(response){
                        this.avisPassage = "Avis déjà enregistré";
                        this.validationPhrase =  "L'avis a été correctement enregistré",
                        this.imgValidation = "/assets/right.png",
                        this.openModalValidation();
                    }
                    else{
                        this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                        this.imgValidation = "/assets/wrong.png",
                        this.openModalValidation();
                    }
                }else{
                    this.validationPhrase =  "Photo manquante",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModalValidation();
                }
            },
            async getUserDatas(email){
                var response = await axios.get('https://so.gaviota.fr/api/userdata/email/'+email);
                if(response.data.user){
                    this.user = response.data.user;
                }
            },
            async getInquiry(id){
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/fromintervention/'+id);
                if(response.data.inquiry){
                    this.inquiry = response.data.inquiry;
                    if(this.inquiry.type === "Entretien chaudière fioul"){
                        this.isFioul = true;
                        this.isGazFilled = true;
                    }
                    else if(this.inquiry.type === "Entretien chaudière gaz"){
                        this.isGaz = true;
                        this.isFioulFilled = true;
                    }
                    else if(this.inquiry.type === "Climatisation"){
                        this.isClim = true;
                        this.isFioulFilled = true;
                        this.isGazFilled = true;
                    }
                    else{
                        this.isFioulFilled = true;
                        this.isGazFilled = true;
                    }

                    if(this.inquiry.TVAsheet){
                        this.isTVAFilled = true;
                    }
                    if(this.inquiry.climsheet){
                        this.isClimFilled = true;
                    }
                    if(this.inquiry.gazsheet){
                        this.isGazFilled = true;
                    }
                    if(this.inquiry.fioulsheet){
                        this.isFioulFilled = true;
                    }

                    this.getBuilding(this.inquiry.name);
                }
            },
            async getBuilding(name){
                var response = await axios.get('https://so.gaviota.fr/api/building/frominquiry/'+name);
                if(response.data.building){
                    this.building = response.data.building;

                    var foundPhone = false;

                    if(this.building.occupantAddress.length){
                        if(this.building.occupantAddress[0].firstName !== "" ||
                            this.building.occupantAddress[0].lastName !== "" || 
                            this.building.occupantAddress[0].streetNb !== "" || 
                            this.building.occupantAddress[0].streetName !== "" || 
                            this.building.occupantAddress[0].postalCode !== "" || 
                            this.building.occupantAddress[0].city !== "" || 
                            this.building.occupantAddress[0].phoneNumber !== "" || 
                            this.building.occupantAddress[0].emailAddress !== ""
                        ){
                            this.txtLocataire = "<b class='textLenSheet'>Locataire :&nbsp;&nbsp;</b>"+
                                                this.building.occupantAddress[0].firstName + " "+this.building.occupantAddress[0].lastName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].streetNb + " "+this.building.occupantAddress[0].streetName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].postalCode + " "+this.building.occupantAddress[0].city+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].phoneNumber +'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.occupantAddress[0].emailAddress;
                        }
                    }
                    if(this.building.ownerAddress){
                        if(this.building.ownerAddress.firstName !== "" ||
                            this.building.ownerAddress.lastName !== "" || 
                            this.building.ownerAddress.streetNb !== "" || 
                            this.building.ownerAddress.streetName !== "" || 
                            this.building.ownerAddress.postalCode !== "" || 
                            this.building.ownerAddress.city !== "" || 
                            this.building.ownerAddress.phoneNumber !== "" || 
                            this.building.ownerAddress.emailAddress !== ""
                        ){
                            this.txtProprio =   "<b class='textLenSheet'>Propriétaire :&nbsp;&nbsp;</b>"+
                                                this.building.ownerAddress.firstName + " "+this.building.ownerAddress.lastName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.streetNb + " "+this.building.ownerAddress.streetName+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                +this.building.ownerAddress.postalCode + " "+this.building.ownerAddress.city+'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.phoneNumber +'<br>'+
                                                '<b class="textLenSheet">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>'+
                                                this.building.ownerAddress.emailAddress;
                        }
                    }
                    if(this.user){
                        if(this.user.address){
                            if(this.user.address.phoneNumber){
                                foundPhone = true;
                                this.ModalAddress = this.user.address.firstName+" "+
                                                    this.user.address.lastName+" - "+
                                                    this.building.buildingAddress.streetNb+" "+
                                                    this.building.buildingAddress.streetName+" "+
                                                    this.building.buildingAddress.postalCode+" "+
                                                    this.building.buildingAddress.city+" - "+
                                                    this.user.address.phoneNumber;
                            }
                        }

                    }
                    if(this.building.occupantAddress && !foundPhone){
                        if(this.building.occupantAddress.length){
                            if(this.building.occupantAddress[0].phoneNumber){
                                foundPhone = true;
                                this.ModalAddress = this.building.occupantAddress[0].firstName+" "+
                                                    this.building.occupantAddress[0].lastName+" - "+
                                                    this.building.buildingAddress.streetNb+" "+
                                                    this.building.buildingAddress.streetName+" "+
                                                    this.building.buildingAddress.postalCode+" "+
                                                    this.building.buildingAddress.city+" - "+
                                                    this.building.occupantAddress[0].phoneNumber;
                            }
                        }
                    }
                    if(this.building.ownerAddress && !foundPhone){
                        if(this.building.ownerAddress.phoneNumber){
                            foundPhone = true;
                            this.ModalAddress = this.building.ownerAddress.firstName+" "+
                                                this.building.ownerAddress.lastName+" - "+
                                                this.building.buildingAddress.streetNb+" "+
                                                this.building.buildingAddress.streetName+" "+
                                                this.building.buildingAddress.postalCode+" "+
                                                this.building.buildingAddress.city+" - "+
                                                this.building.ownerAddress.phoneNumber;
                        }                        
                    }
                }
            },
            async getIntervention(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/intervention/light/'+this.$route.query.name);
                if(response.data.intervention){
                    this.intervention = response.data.intervention;
                    this.ModalNote = this.intervention.note;
                    this.title = this.intervention.planning[0].addressStr + "  -  " + this.intervention.type;

                    for(var t=0; t<this.intervention.planning.length; t++){
                        if(this.intervention.planning[t].user.idWeweb === this.$cookie.get('idWeweb') && this.intervention.planning[t].isMain){
                            this.isMain = true;
                        }
                    }

                    this.nbDoc = this.intervention.picture.length;
                    if(this.intervention.sketch){
                        this.nbDoc = this.nbDoc+1;
                    }
                    if(this.intervention.noticeFiled){
                        this.nbDoc = this.nbDoc+1;
                    }
                    if(this.intervention.intervention){
                        this.nbDoc = this.nbDoc+1;
                    }

                    if(this.intervention.intervention){
                        if(this.intervention.intervention.action.length && this.intervention.intervention.information.length){
                            this.isInterventionSheet = true;
                            this.nbInfo = this.intervention.intervention.information.length;
                            this.nbAction = this.intervention.intervention.action.length;
                        }
                    }
                    if(this.intervention.noticeFiled){
                        this.avisPassage = "Avis déjà enregistré";
                    }
                    if(this.intervention.sketch){
                        this.sketchStatus = "Croquis déjà enregistré"
                    }
                    if(this.intervention.picture){
                        if(this.intervention.picture.length){
                            if(this.intervention.picture.length === 1){
                                this.nbPic = this.intervention.picture.length + " photo"
                            }
                            else{
                                this.nbPic = this.intervention.picture.length + " photos"
                            }
                        }
                        else{
                            this.nbPic = "Aucune photo";
                        }
                    }
                    else{
                        this.nbPic = "Aucune photo";
                    }
                    var LOCmainTechTime =0;
                    var LOCinterimTime =[];
                    var LOChelpTime =[];
                    var LOCcumulateTime =0;
                    var foundHelp = false;
                    var foundInt = false;

                    for(var f=0; f<this.intervention.planning.length; f++){
                        if(!this.intervention.planning[f].isEstimated){
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain){
                                LOCmainTechTime += this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                            }
                            if(!this.intervention.planning[f].isEstimated && !this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire")===-1){
                                foundHelp = false;
                                for(var g=0; g<LOChelpTime.length; g++){
                                    if(LOChelpTime[g].user === this.intervention.planning[f].user.idWeweb){
                                        foundHelp = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOChelpTime[g].time = LOChelpTime[g].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundHelp){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOChelpTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                            if(!this.intervention.planning[f].isEstimated && this.intervention.planning[f].isMain && this.intervention.planning[f].user.idWeweb.indexOf("interimaire") > -1){
                                foundInt = false;
                                for(var h=0; h<LOCinterimTime.length; h++){
                                    if(LOCinterimTime[h].user === this.intervention.planning[f].user.idWeweb){
                                        foundInt = true;
                                        LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                        LOCinterimTime[h].time = LOCinterimTime[h].time + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    }
                                }
                                if(!foundInt){
                                    LOCcumulateTime = LOCcumulateTime + this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp;
                                    LOCinterimTime.push({time:this.intervention.planning[f].endTimestamp - this.intervention.planning[f].startTimestamp, user:this.intervention.planning[f].user.idWeweb});
                                }
                            }
                        }
                    }
                    this.mainTechHour = ""+Math.floor(LOCmainTechTime / 3600);
                    this.mainTechMinute = ""+Math.floor(LOCmainTechTime % 3600 / 60);

                    for(var e=0; e<LOCinterimTime.length; e++){
                        if(e>0){
                            this.interimHour.push(""+Math.floor(LOCinterimTime[e] / 3600));
                            this.interimMinute.push(""+Math.floor(LOCinterimTime[e] % 3600 / 60));
                        }
                        else{
                            this.interimHour[0] = (""+Math.floor(LOCinterimTime[e] / 3600));
                            this.interimMinute[0] = (""+Math.floor(LOCinterimTime[e] % 3600 / 60));
                        }
                    }
                    if(LOCinterimTime.length === 0){
                        this.interimHour = [];
                        this.interimMinute = [];
                    }
                    for(var d=0; d<LOChelpTime.length; d++){
                        if(d>0){
                            this.helpHour.push(""+Math.floor(LOChelpTime[d] / 3600));
                            this.helpMinute.push(""+Math.floor(LOChelpTime[d] % 3600 / 60));
                        }
                        else{
                            this.helpHour[0] = (""+Math.floor(LOChelpTime[d] / 3600));
                            this.helpMinute[0] = (""+Math.floor(LOChelpTime[d] % 3600 / 60));
                        }
                    }
                    if(LOChelpTime.length === 0){
                        this.helpHour = [];
                        this.helpMinute = [];
                    }

                    this.cumulateHour = Math.floor(""+LOCcumulateTime / 3600);
                    this.cumulateMinute = Math.floor(""+LOCcumulateTime % 3600 / 60);
                }
                this.getInquiry(this.$route.query.name);
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');

    #startintervention {
        width: 90%;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 85px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    h2{
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:11;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }
    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }
    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    #circleRed {
        width: 16px;
        height: 16px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        border-radius: 8px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: -6px;
        right: 67px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        color:white;
        text-align: center;
        font-size:13px;
        vertical-align: middle;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    #logout{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
	::-webkit-scrollbar {
		width: 6px;
	}
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .calendar{
        font-family: 'BenchNine', sans-serif;
        font-size: 14px;
        margin: 40px auto;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalDivCenter{
        text-align: center;
    }
    .modalAmount{
        width:100px;
        margin:auto;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .modalNotes{
        background-color: #F0F0F0;
        resize: none;
        width:80%;
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
    .docBtn4{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:black;
        font-size: 18px;
        margin-top:15px;
        cursor: pointer;
        background-color: #1ce83e;
        border-radius:10px;
        width: 200px;
    }
    .bigBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 20px;
        cursor: pointer;
        background-color: #191919;
        border-radius:10px;
        padding: 30px;
        margin: 15px;
        width: 90%;
    }
    .marginBotTop{
        margin-bottom:20px;
        margin-top:20px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .textLen{
        width:160px;
        display: inline-block;
    }
    .inputTxt{
        width:calc(100% - (100px + 50px));
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
    .select{
        width: calc(100% - (100px + 40px));
        margin-bottom:10px;
    }
    .textline{
        padding:5px;
    }
    .wrapperDateSmall{
        display: inline-block;
        width:calc(100% - (140px + 40px));
    }
    .inputSmall{
        display: inline-block;
        width:30px;
    }
    .inputSmallDis{
        display: inline-block;
        width:30px;
        background-color: #FFFFFF;
         outline: none;
         border: 0px solid;
    }
    .area{
        resize: none;
        width: 95% !important;
    }
    .high{
        height: 100px;
        vertical-align:top;
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        padding-left: 15px;
        padding-bottom: 25px;
        padding-top: 10px;
        border-bottom: 2px solid;
        border-color:#00000017;
    }
    .spanCardtype{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 15px;
        position: absolute;
        left: 16px;
    }
    .spanCardstatus{
        display:inline-block;
        color:red;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 16px;
        position: absolute;
        right: 55px;
    }
    .spanCardtitle{
        display:block;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .btnCardCamera{
        width:30px;
        height: 30px;
        border-radius: 50%;
        font-size: 18px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
    }
    #modify{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 700;
        font-size: 20px;
        display: block;
        border: 2px solid;
        border-color:#1ce83e;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: transparent;
        border-radius:10px;
    }
    .radioBtn{
        margin-left:10px;
        margin-right:5px;
    }
    input[type='radio']:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #d1d3d1;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background: radial-gradient(#1ce83e, #ddd);
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    .signature{
        display: inline-block;
        border: 2px solid;
        border-color:#888;
        background-color: white;
    }
    .fullheight{
        min-height: calc(80vh - 60px);
    }
    .textLenSheet{
        width:120px !important;
        display: inline-block;
    }
    .btnNewBtn{
        width:25px;
        height: 25px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:black;
        cursor: pointer;
        background-color: #1ce83e;
        display:inline-block;
        margin:10px;
    }
    .twocolumns{        
        -webkit-column-count: 2; /* Old Chrome, Safari and Opera */
        -moz-column-count: 2; /* Old Firefox */
        column-count: 2;
    }
    .modalCheck{
        width:30px;
        /* Double-sized Checkboxes */
        -ms-transform: scale(1.5); /* IE */
        -moz-transform: scale(1.5); /* FF */
        -webkit-transform: scale(1.5); /* Safari and Chrome */
        -o-transform: scale(1.5); /* Opera */
        transform: scale(1.5);
        margin-left: 30px;
    }
</style>
<style lang="scss" module>
    html>body>div>div>div>div>div>div>div>div>div>input{
                    width:100% !important;
                    font-family: 'BenchNine', sans-serif;
                    font-stretch: ultra-condensed;
                    font-size: 18px;
                    background-color: #F7F7F7;
                    border: 1px solid #bbb;
                    padding-left:5px;
                    margin-left:5px;
                    display: inline-block;
    }
    html>body>div>div>div>div>div>div>div>span>input{
                    width:100% !important;
                    font-family: 'BenchNine', sans-serif;
                    font-stretch: ultra-condensed;
                    font-size: 18px;
                    background-color: #F7F7F7;
                    border: 1px solid #bbb;
                    padding-left:5px;
                    margin-left:5px;
                    display: inline-block;
    }
    .wrapperDateSmall{
        display: inline-block;
        width:calc(100% - (140px + 40px));
    }
</style>